import { Box, Flex } from "@chakra-ui/react";
import { Col, Row } from "antd";
import Field from "components/Input/Field";
import SelectContaBancaria from "components/Input/SelectContaBancaria";
import SelectPessoas from "components/Input/SelectPessoas";
import { TipoEntidadeEnum } from "core/resources/enums/conta";
import SelectContaCategoria from "ui/components/Input/SelectContaCategoria";
import SelectableButton from "components/Button/SelectableButton";
import colors from "resources/theme/colors";
import { FiltrosAdicionaisProps } from "../FiltrosAdicionais";
import { RelatorioIdEnum } from "core/features/relatorios/typings";
import SelectFechamentosRateioPorMes from "components/Input/SelectFechamentosRateioPorMes";
import SelectCentroDeCusto from "components/Input/SelectCentroDeCusto";
import { OperacaoEnum } from "core/resources/enums/conta";
import SelectTipoData from "components/Input/SelectTipoData";

function FiltrosAdicionaisContasETotalDespesas({
  index,
  control,
  item,
  includeTags = true,
  includeFavorecido,
}: FiltrosAdicionaisProps & {
  includeTags?: boolean;
  includeFavorecido?: boolean;
}) {
  const getOperacao = () => {
    if (
      [
        RelatorioIdEnum.Receitas,
        RelatorioIdEnum.ReceitasComComposicao,
        RelatorioIdEnum.ComposicaoReceitasHorizontal,
      ].includes(item.relatorioId!)
    ) {
      return OperacaoEnum.Receita;
    }

    if (
      [
        RelatorioIdEnum.TotalDeDespesas,
        RelatorioIdEnum.DespesasComComposicao,
      ].includes(item.relatorioId!)
    ) {
      return OperacaoEnum.Despesa;
    }
  };

  return (
    <Flex flexDir="column">
      <Box as={Row} gutter={16} mb={4}>
        <Box as={Col} xs={24}>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.tipoData`}
            label="Tipo de data"
            render={({ field }) => (
              <SelectTipoData
                bg="white"
                style={{ border: "1px solid #ccc", borderRadius: 6 }}
                value={field.value}
                onChange={field.onChange}
                operacao={getOperacao()}
              />
            )}
          />
        </Box>
      </Box>

      <Box as={Row} gutter={16} mb={4}>
        <Box as={Col} xs={24}>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.search`}
            label="Busca"
          />
        </Box>
      </Box>

      <Box as={Row} gutter={16} mb={4}>
        <Box as={Col} xs={12}>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.categoriaIds`}
            label="Contas categorias"
            render={({ field }) => <SelectContaCategoria {...field} multiple />}
          />
        </Box>

        <Box as={Col} xs={12}>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.contaBancariaIds`}
            label="Contas bancárias"
            render={({ field }) => (
              <SelectContaBancaria {...field} mode="multiple" />
            )}
          />
        </Box>
      </Box>

      {includeFavorecido ? (
        <Box as={Row} gutter={16} mb={4}>
          <Box as={Col} xs={24}>
            <Field
              control={control}
              name={`items.${index}.parametros.filtrosAdicionais.pessoaId`}
              label="Favorecido"
              render={({ field }) => (
                <SelectPessoas
                  {...field}
                  tipoEntidades={[
                    TipoEntidadeEnum.Fornecedor,
                    TipoEntidadeEnum.Condomino,
                    TipoEntidadeEnum.Funcionario,
                    TipoEntidadeEnum.Outros,
                  ]}
                  placeholder="Selecione"
                />
              )}
            />
          </Box>
        </Box>
      ) : null}

      <Box as={Row} gutter={16} mb={4}>
        <Box as={Col} xs={12}>
          <Field
            control={control}
            name={`items.${index}.parametros.filtrosAdicionais.centrosDeCustoIds`}
            label="Centros de custo"
            render={({ field }) => (
              <SelectCentroDeCusto mode="multiple" {...field} />
            )}
          />
        </Box>

        {item.relatorioId === RelatorioIdEnum.TotalDeDespesas ? (
          <Box as={Col} xs={12}>
            <Field
              control={control}
              name={`items.${index}.parametros.filtrosAdicionais.rateioFechamentoId`}
              label="Rateio"
              render={({ field }) => (
                <SelectFechamentosRateioPorMes
                  {...field}
                  placeholder="Selecione"
                />
              )}
            />
          </Box>
        ) : null}
      </Box>

      {includeTags ? (
        <Box as={Row} gutter={16} mb={4}>
          <Box as={Col} xs={24}>
            <Field
              control={control}
              name={`items.${index}.parametros.filtrosAdicionais.pago`}
              label="Situacão"
              render={({ field }) => (
                <Flex gridGap={4}>
                  <SelectableButton
                    selected={field.value === "0"}
                    onClick={() => field.onChange("0")}
                    onUnselect={() => field.onChange(undefined)}
                    rounded="full"
                    selectedColor={colors.green500}
                    fontSize="14px"
                  >
                    Em aberto
                  </SelectableButton>
                  <SelectableButton
                    selected={field.value === "1"}
                    onClick={() => field.onChange("1")}
                    onUnselect={() => field.onChange(undefined)}
                    rounded="full"
                    selectedColor={colors.blue300}
                    fontSize="14px"
                  >
                    Liquidadas
                  </SelectableButton>
                </Flex>
              )}
            />
          </Box>
        </Box>
      ) : null}
    </Flex>
  );
}

export default FiltrosAdicionaisContasETotalDespesas;
